import { useEditorState } from "@tiptap/react";

/**
 * Tracks which formats are active at the current selection in a TipTap editor,
 * so toolbar buttons can show what is toggled on (bold, H1, lists, ...).
 *
 * TipTap v3 does not re-render on every transaction by default, so this uses
 * `useEditorState` to re-render only when one of these values changes.
 *
 * @param {import("@tiptap/react").Editor | null} editor
 * @returns {Record<string, boolean>}
 */
export default function useEditorActiveFormats(editor) {
  return (
    useEditorState({
      editor,
      selector: ({ editor }) => {
        if (!editor) return {};
        return {
          bold: editor.isActive("bold"),
          italic: editor.isActive("italic"),
          strike: editor.isActive("strike"),
          h1: editor.isActive("heading", { level: 1 }),
          h2: editor.isActive("heading", { level: 2 }),
          h3: editor.isActive("heading", { level: 3 }),
          bulletList: editor.isActive("bulletList"),
          orderedList: editor.isActive("orderedList"),
          taskList: editor.isActive("taskList"),
          blockquote: editor.isActive("blockquote"),
          codeBlock: editor.isActive("codeBlock"),
        };
      },
    }) || {}
  );
}
